// react-redux imports
import { useEffect } from "react";
import { useDispatch } from "react-redux";

// common imports
import SectionContainer from "common/components/styled-components/SectionContainer";
import recycleBackground from "common/img/recycle-background.jpg";
import waterBackground from "common/img/water-background.jpg";

import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";

// action imports
import { setUrl } from "features/background/backgroundSlice";

interface HouseholdHabitsProps {
  step: number;
}

const steps = [<StepOne />, <StepTwo />, <StepThree />];

function HouseholdHabits({ step }: HouseholdHabitsProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUrl(step === 1 ? waterBackground : recycleBackground));
  });

  return <SectionContainer>{steps[step - 1]}</SectionContainer>;
}

export default HouseholdHabits;
